import React from 'react';
export const Nav01DataSource = {
  wrapper: { className: 'header0 home-page-wrapper' },
  page: { className: 'home-page' },
  logo: {
    className: 'header0-logo',
    children: 'https://www.bmr-oe.com/static/images/logo15.png',
  },
  Menu: {
    className: 'header0-menu',
    children: [
      {
        name: 'item~mf1vwp7ocwh',
        className: 'header0-item',
        children: {
          href: '/#',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <p>首页</p>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item0',
        className: 'header0-item',
        children: {
          href: '#',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <p>产品中心</p>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
        subItem: [
          {
            name: 'sub0',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m9m6cmyd7qg-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/强激光78.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8wyzpxxeu-editor_css',
                  children: (
                    <span>
                      <span>
                        <p>强激光双轴快反镜</p>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second1',
            },
          },
          {
            name: 'sub1',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/通用双轴50.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <p>通用双轴快反镜</p>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second2',
            },
          },
          {
            name: 'sub~m8x12rhcd3r',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/单轴50.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <p>单轴快反镜</p>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second3',
            },
          },
          {
            name: 'sub~m8x12unqvh',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/摆扫镜30.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <span>
                                    <p>摆扫镜</p>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second4',
            },
          },
          {
            name: 'sub~m8x12vr6qz',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/振镜6240.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <p>加固振镜</p>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second5',
            },
          },
          {
            name: 'sub~m8x12wndado',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/电调镜78.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <p>电调镜</p>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second6',
            },
          },
          {
            name: 'sub~m8x12xgznka',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/电动镜127.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <p>电动镜</p>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second7',
            },
          },
          {
            name: 'sub~m8x12yp8s7o',
            className: 'item-sub m976jn6jedn-editor_css',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/激光通信20.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <span>
                                    <span>
                                      <span>
                                        <span>
                                          <span>
                                            <p>激光通信快反镜</p>
                                          </span>
                                        </span>
                                      </span>
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second8',
            },
          },
          {
            name: 'sub~m9m6exgl0t',
            className: 'item-sub m976jn6jedn-editor_css',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/永磁同步75.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <span>
                                    <span>
                                      <span>
                                        <span>
                                          <p>无槽永磁同步电机</p>
                                        </span>
                                      </span>
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second9',
            },
          },
        ],
      },
      {
        name: 'item1',
        className: 'header0-item',
        children: {
          href: '/#/fourth',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <p>现货商城</p>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item2',
        className: 'header0-item',
        children: {
          href: '/#/tenth',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <p>应用领域</p>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item3',
        className: 'header0-item',
        children: {
          href: '/#/fifth',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <p>新闻动态</p>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item~m98pdg3g8rs',
        className: 'header0-item',
        children: {
          href: '/#/sixth',
          children: [
            {
              children: (
                <span>
                  <span>
                    <p>联系我们</p>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
    ],
  },
  mobileMenu: { className: 'header0-mobile-menu' },
};
export const Banner10DataSource = {
  wrapper: { className: 'banner1 m8wmyqt62ma-editor_css' },
  BannerAnim: {
    children: [
      {
        name: 'elem0',
        BannerElement: { className: 'banner-user-elem' },
        textWrapper: { className: 'banner1-text-wrapper' },
        bg: { className: 'bg bg0 m8wmxqt4hsf-editor_css' },
        title: { className: 'banner1-title', children: '' },
        content: {
          className: 'banner1-content m8wt5yzvohu-editor_css',
          children: (
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <blockquote>
                                铂米瑞光电，快反镜行业领跑者
                              </blockquote>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          ),
        },
        button: {
          className: 'banner1-button m8wtjvr1hjk-editor_css',
          children: (
            <span>
              <span>
                <p>
                  <br />
                </p>
              </span>
            </span>
          ),
        },
      },
      {
        name: 'elem2',
        BannerElement: { className: 'banner-user-elem' },
        textWrapper: { className: 'banner1-text-wrapper' },
        bg: { className: 'bg bg1 m96u0zciy-editor_css' },
        title: { className: 'banner1-title', children: '' },
        content: {
          className: 'banner1-content m96ve128cj-editor_css',
          children: (
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <p>专注光电领域二十余年</p>
                        <p>匠心出精品</p>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          ),
        },
        button: {
          className: 'banner1-button m96u6oixptm-editor_css',
          children: (
            <span>
              <p>
                <br />
              </p>
            </span>
          ),
        },
      },
    ],
    autoPlay: true,
    type: ['across'],
    autoPlaySpeed: 5000,
  },
};
export const Pricing00DataSource = {
  wrapper: { className: 'home-page-wrapper pricing0-wrapper' },
  OverPack: {
    playScale: 0.3,
    className: 'home-page pricing0 m99p23i1scq-editor_css',
  },
  imgWrapper: { className: 'pricing0-img-wrapper', md: 12, xs: 24 },
  img: {
    className: 'pricing0-img m978rqsq4x7-editor_css',
    name: 'image',
    children:
      'https://www.bmr-oe.com/static/images/bg/摆扫镜30.png',
  },
  childWrapper: {
    className: 'pricing0-text-wrapper',
    md: 12,
    xs: 24,
    children: [
      {
        name: 'title',
        children: (
          <span>
            <span>
              <span>
                <span>
                  <span>
                    <p>摆扫镜</p>
                  </span>
                </span>
              </span>
            </span>
          </span>
        ),
        className: 'pricing0-title m978rylb0e9-editor_css',
      },
      {
        name: 'content',
        children: (
          <span>
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <p>
                                  &nbsp; &nbsp; &nbsp; &nbsp;
                                  摆扫镜利用两相永磁同步电机驱动反射镜进行精确的光路扫描控制，结合高灵敏度、高精度的光电传感器,
                                  并配合小型驱动板，构成大带宽、高速度扫描系统。该摆扫镜采用碳化硅反射镜，在重量、强度、热稳定性和光学性能之间取得了很好的平衡。通光口径可达10mm～35mm，非常适合在制冷红外周视系统中做像移补偿，并可适配320、640、1024等多种像元数。<br />
                                </p>
                                <p>
                                  <br />
                                </p>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          </span>
        ),
        className: 'pricing0-content m978pqodl6-editor_css',
      },
      {
        name: 'content~m978qbprd5o',
        className: 'm978qgtjt2d-editor_css',
        children: (
          <span>
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <p>性能参数见以下具体型号：</p>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          </span>
        ),
      },
    ],
  },
};
export const Content51DataSource = {
  wrapper: {
    className: 'home-page-wrapper content5-wrapper m9795l42uan-editor_css',
  },
  page: { className: 'home-page content5 m978u3wfeie-editor_css' },
  OverPack: { playScale: 0.3, className: 'mf9bxqkdkxo-editor_css' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'content',
        className: 'title-content m8fsbn35n98-editor_css',
        children: (
          <span>
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <p>
                          <br />
                        </p>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          </span>
        ),
      },
    ],
  },
  block: {
    className: 'content5-img-wrapper mf9bxy42tfc-editor_css',
    gutter: 16,
    children: [
      {
        name: 'block0',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: {
            className: 'content5-block-content',
            href: '/#/second41',
          },
          img: {
            children:
              'https://www.bmr-oe.com/static/images/bg/摆扫镜25.png',
            className: 'm9m7o0eacwt-editor_css',
          },
          content: {
            children: (
              <span>
                <span>
                  <span>
                    <p>BMR7530-25</p>
                  </span>
                </span>
              </span>
            ),
            className: 'm9m6ar9sku7-editor_css',
          },
        },
      },
      {
        name: 'block1',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: {
            className: 'content5-block-content',
            href: '/#/second42',
          },
          img: {
            children:
              'https://www.bmr-oe.com/static/images/bg/摆扫镜25.png',
            className: 'm9m7o53bvq8-editor_css',
          },
          content: {
            children: (
              <span>
                <span>
                  <span>
                    <p>BMR7530-30</p>
                  </span>
                </span>
              </span>
            ),
            className: 'm9m6b4aly1-editor_css',
          },
        },
      },
    ],
  },
};
export const Footer10DataSource = {
  wrapper: { className: 'home-page-wrapper footer1-wrapper' },
  OverPack: { className: 'footer1', playScale: 0.2 },
  block: {
    className: 'home-page',
    gutter: 0,
    children: [
      {
        name: 'block0',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          className: 'logo',
          children:
            'https://www.bmr-oe.com/static/images/logo15.png',
        },
        childWrapper: {
          className: 'slogan',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <p>快反镜行业领跑者</p>
                </span>
              ),
              className: 'm8frbj7scy-editor_css',
            },
          ],
        },
      },
      {
        name: 'block1',
        xs: 24,
        md: 6,
        className: 'block',
        title: { children: '产品' },
        childWrapper: {
          children: [
            {
              name: 'link0',
              href: '/产品手册-V1.1.pdf',
              children: (
                <span>
                  <span>
                    <p>选型手册</p>
                  </span>
                </span>
              ),
            },
            {
              name: 'link2',
              href: '/接口定义-V1.0.pdf',
              children: (
                <span>
                  <span>
                    <span>
                      <p>接口定义</p>
                    </span>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block2',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          children: (
            <span>
              <p>资源</p>
            </span>
          ),
        },
        childWrapper: {
          children: [
            {
              href: '/#/eighth',
              name: 'link0',
              children: (
                <span>
                  <span>
                    <p>常见问题</p>
                  </span>
                </span>
              ),
            },
            {
              href: '/#/ninth',
              name: 'link1',
              children: (
                <span>
                  <p>在线工具</p>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block3',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          children: (
            <span>
              <p>关于</p>
            </span>
          ),
        },
        childWrapper: {
          children: [
            {
              href: '/#/seventh',
              name: 'link0',
              children: (
                <span>
                  <span>
                    <span>
                      <p>公司简介</p>
                    </span>
                  </span>
                </span>
              ),
            },
            {
              href: '/#/sixth',
              name: 'link1',
              children: (
                <span>
                  <span>
                    <span>
                      <p>联系我们</p>
                    </span>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
    ],
  },
  copyrightWrapper: { className: 'copyright-wrapper' },
  copyrightPage: { className: 'home-page' },
  copyright: {
    className: 'copyright',
    children: (
      <span>
        <span>©2025 by 上海铂米瑞&nbsp;All Rights Reserved &nbsp; 沪ICP备2025124982号</span>
      </span>
    ),
  },
};
